import { render, staticRenderFns } from "./EventFlowLegend.vue?vue&type=template&id=687d7896&scoped=true"
import script from "./EventFlowLegend.vue?vue&type=script&lang=ts"
export * from "./EventFlowLegend.vue?vue&type=script&lang=ts"
import style0 from "./EventFlowLegend.vue?vue&type=style&index=0&id=687d7896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d7896",
  null
  
)

export default component.exports